import * as ApiModels from '@typings/api-models';
import s from './WorkflowContext.module.scss';

type Props = {
  item: ApiModels.TaskTypedData & {
    userWorkflow: {
      contexts: Array<{
        id: string;
        label: string;
        value: string;
        rank: number;
      }>;
      person: Pick<ApiModels.Person, 'id' | 'name' | 'email'>;
    } | null;
  };
};

const WorkflowContext: React.FC<Props> = ({ item }) => (
  <ul className={s.list}>
    {item.userWorkflow && (
      <li className={s.item}>
        <span className={s.label}>Contact:</span>
        <span className={s.value}>{item.userWorkflow.person.name || item.userWorkflow.person.email}</span>
      </li>
    )}
    {item.userWorkflow && item.userWorkflow.contexts.map(context => (
      <li className={s.item} key={context.id}>
        <span className={s.label}>{context.label}:</span>
        <span className={s.value}>{context.value}</span>
      </li>
    ))}
    {!item.userWorkflow && item.action === 'respond-to-conversation' && item.data.customerName && (
      <li className={s.item}>
        <span className={s.label}>Contact:</span>
        <span className={s.value}>{item.data.customerName}</span>
      </li>
    )}
  </ul>
);

export default WorkflowContext;
